import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './UnreadActionType';
import * as actions from './UnreadAction';
import * as services from './UnreadServices';

//------------------ Unread Exam Data - start------------------//
function* fetchUnreadExamDataSaga(action) {
    try {
        console.log('Unread API Request - Payload:', JSON.stringify(action.payload, null, 2));
        const response = yield call(services.getAllUnreadData, action.payload);
        console.log('Unread API Response - Success:', response);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchUnreadExamDataSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to fetch unread exam data.';
        console.error('Unread Exam Data API Error:', {
            status: error.response?.status,
            statusText: error.response?.statusText,
            message: errorMessage,
            data: error.response?.data,
            requestPayload: action.payload,
            timestamp: new Date().toISOString()
        });
        yield put(actions.fetchUnreadExamDataFailure(errorMessage));
    }
}
//------------------ Unread Exam Data - end------------------//

export default function* watchUnreadSaga() {
    yield takeEvery(types.FETCH_UNREAD_EXAM_DATA_REQUEST, fetchUnreadExamDataSaga);
}